import React, { useState, useEffect, Suspense, lazy } from "react"
import { Routes, Route, useLocation } from "react-router-dom"
import TitleAndMetaTags from "../../Components/Common/TitleAndMetaTags"
import Header from "../../Components/Shared/Header"
import Footer from "../../Components/Shared/Footer"
import LoadingSpinner from "../../Components/Common/LoadingSpinner"
import { PhysicalCardTypes } from "../../Code/Data"
import LandingPage from "../LandingPage"
import useViewportMinimized from "../../Code/useViewportMinimized"

const About = lazy(() => import("../About"))
const WhatIs = lazy(() => import("../WhatIs"))
const CorporateSolutions = lazy(() => import("../CorporateSolutions"))
const NPO = lazy(() => import("../NPO"))
const DAF = lazy(() => import("../DAF"))
const AfghanistanRefugees = lazy(() => import("../AfghanistanRefugees"))
const DigitalCards = lazy(() => import("../Purchase/DigitalCards"))
const ContactPage = lazy(() => import("../Contact"))
const TopCharities = lazy(() => import("../TopCharities"))
const DynamicPage = lazy(() => import("../DynamicPage"))
const CreateUserRedemptionPage = lazy(() => import("../../Components/CreateUserRedemptionPage"))
const RedeemCodes = lazy(() => import("../RedeemCodes"))
const Support = lazy(() => import("../Support"))
const SupportIsraelFoodCard = lazy(() => import("../SupportIsraelFoodCard"))
const DonateYourCard = lazy(() => import("../DonateYourCard"))
const DirectToCharityDonation = lazy(() => import("../../Components/DirectToCharityDonation"))
const BrandDigitalCard = lazy(() => import("../BrandDigitalCard"))
const GoodGoodGood = lazy(() => import("../Goodgoodgood"))
const OurCharities = lazy(() => import("../../Components/OurCharities"))
const CharityDetail = lazy(() => import("../../Components/OurCharities/CharityDetail"))
const HonorCards = lazy(() => import("../Purchase/HonorCards"))
const PhysicalCards = lazy(() => import("../Purchase/PhysicalCards"))
const PurchaseRedemptionCodes = lazy(() => import("../../Components/PurchaseRedemptionCodes"))
const FavorsSwagQRCodes = lazy(() => import("../../Components/PurchaseFavorsSwagQRCodes"))

/*
const LoginPage = lazy(() => import("../LoginPage"))
const CreditCheckout = lazy(() => import("../CreditCheckout"))
const PayPalCheckout = lazy(() => import("../PayPalCheckout"))
const CorporateCheckout = lazy(() => import("../ShoppingCart/CorporateCheckout"))
const CustomPhysicalCards = lazy(() => import("../Purchase/CustomPhysicalCards"))
const OrderComplete = lazy(() => import("../Purchase/OrderComplete"))
const ShoppingCart = lazy(() => import("../ShoppingCart"))
*/

export default function Main() {
  const isDonateYourCardDomain = window.location.hostname.includes("donateyourcard.org");
  const DEFAULT_BLURB = "An Official Donation Site of the American Red Cross";
  const isMinimized = useViewportMinimized()
  const [isDonateYourCard, setIsDonateYourCard] = useState(isDonateYourCardDomain);
  const [selectedCharity, setSelectedCharity] = useState();
  const [bottomBlurb, setBottomBlurb] = useState(DEFAULT_BLURB)
  const location = useLocation();

  useEffect(() => {
    // Reset default bottom blurb whenever navigating
    setBottomBlurb(DEFAULT_BLURB);
  }, [location.pathname]);

  return (
    <>
      <TitleAndMetaTags />
      {(!isMinimized || location?.pathname !== "/") &&
        <Header isDonateYourCard={isDonateYourCard} selectedCharity={selectedCharity} />}
      <Suspense fallback={<div className="text-center p-5"><LoadingSpinner /></div>}>
        <Routes>
          {isDonateYourCardDomain
            ? <Route path="/:charityId?/:charityName?"
              element={<DonateYourCard selectedCharity={selectedCharity} setSelectedCharity={setSelectedCharity} setIsDonateYourCard={setIsDonateYourCard} setBottomBlurb={setBottomBlurb} />}
            />
            : <Route path="/" element={<LandingPage />} />
          }
          <Route path="/GiveGiftCards" element={<LandingPage />} />
          <Route path="/NPO" element={<NPO />} />
          <Route path="/About" element={<About isDonateYourCard={isDonateYourCard} />} />
          <Route path="/WhatIs" element={<WhatIs />} />
          <Route path="/CorporateSolutions" element={<CorporateSolutions />} />
          <Route path="/Purchase/DigitalCards">
            <Route index element={<DigitalCards />} />
            <Route path=":CardId/:CardName"
              element={<DigitalCards />}
            />
            <Route path=":CardId"
              element={<DigitalCards />}
            />
          </Route>
          <Route path="/Purchase/HonorCards">
            <Route index element={<HonorCards setBottomBlurb={setBottomBlurb} />} />
            <Route path=":CardId/:CardName"
              element={<HonorCards setBottomBlurb={setBottomBlurb} />}
            />
            <Route path=":CardId"
              element={<HonorCards setBottomBlurb={setBottomBlurb} />}
            />
          </Route>
          <Route path="/DAF" element={<DAF />} />
          <Route path="/AfghanistanRefugees" element={<AfghanistanRefugees />} />
          <Route path="/Contact" element={<ContactPage />} />
          <Route path="/TopCharities" element={<TopCharities />} />
          <Route path="/DynamicPage" element={<DynamicPage />} />
          <Route
            path="/Account/CreateUserRedemptionPage"
            element={<CreateUserRedemptionPage />}
          />
          {/*Note the route /Redeem/Custom (user redemption page) is set in src\Contents\App\index.jsx 
          as it doesn't show a Header etc.*/}
          <Route path="/Redeem" element={<RedeemCodes />} />
          {/*<Route path="/Redeem/multi" element={<RedeemCodes />} />*/}
          <Route path="/Support/:charityIdOrName/:charityNameOrId?" element={<Support />} />
          <Route
            path="/SupportIsraelFoodCard"
            element={<SupportIsraelFoodCard />}
          />
          <Route path="/Purchase/Favors-Swag-QR-Codes/:charityId?/:charityName?"
            element={<FavorsSwagQRCodes setBottomBlurb={setBottomBlurb} />}
          />
          <Route path="/Purchase/DirectToCharityDonation/:charityId?/:charityName?"
            element={<DirectToCharityDonation setBottomBlurb={setBottomBlurb} />}
          />
          {(isDonateYourCardDomain
            ? <Route path="/FAQs"
              element={<DonateYourCard showFAQs={true} selectedCharity={selectedCharity} setSelectedCharity={setSelectedCharity} setIsDonateYourCard={setIsDonateYourCard} setBottomBlurb={setBottomBlurb} />}
            />
            : <Route path="/DonateYourCard/FAQs"
              element={<DonateYourCard showFAQs={true} selectedCharity={selectedCharity} setSelectedCharity={setSelectedCharity} setIsDonateYourCard={setIsDonateYourCard} setBottomBlurb={setBottomBlurb} />}
            />)}
          <Route path="/DonateYourCard/:charityId?/:charityName?"
            element={<DonateYourCard selectedCharity={selectedCharity} setSelectedCharity={setSelectedCharity} setIsDonateYourCard={setIsDonateYourCard} setBottomBlurb={setBottomBlurb} />}
          />
          <Route
            path="/CorporateSolutions/BrandDigitalCard"
            element={<BrandDigitalCard />}
          />
          <Route path="/Charities/Cat?/:categoryId?/:categoryName?" element={<OurCharities />} />
          <Route path="/OurCharities" element={<OurCharities />} />
          <Route path="/Charity/:charityId/:charityName?" element={<CharityDetail setBottomBlurb={setBottomBlurb} />} />
          <Route path="/Goodgoodgood" element={<GoodGoodGood />} />

          <Route path="/Purchase/PhysicalCards" element={<PhysicalCards />} />
          <Route path="/Purchase/CustomPhysicalCards"
            element={<PhysicalCards initialCardType={PhysicalCardTypes.Custom} />} />
          <Route path="/Purchase/RedemptionCodes" element={<PurchaseRedemptionCodes />} />

          {/* <Route  path="/Login"  element={LoginPage} />          
          <Route  path="/Purchase/PhysicalCards"  element={PhysicalCards} />
          <Route  path="/Purchase/CustomPhysicalCards">
            <Redirect to="/Purchase/PhysicalCards" />
          </Route>
          <Route  path="/Purchase/HonorCards"  element={HonorCards} />
          <Route  path="/Purchase/RedemptionCodes"  element={RedemptionCodes} />
          <Route path="/DonateYourCard"  element={DonateYourCard} />
          <Route path="/GCE">
            <Redirect to="/DonateYourCard" />
          </Route>
          <Route  path="/ShoppingCart"  element={ShoppingCart} />
          <Route  path="/Purchase/CreditCheckout"  element={CreditCheckout} />
          <Route  path="/Purchase/PayPalCheckout"  element={PayPalCheckout} />
          <Route  path="/Purchase/CorporateCheckout"  element={CorporateCheckout} />
          <Route  path="/Purchase/OrderComplete"  element={OrderComplete} />
          <Route path="/Support/:charityIdOrName"  element={Support} />
          <Route path="/ShoppingCart" element={<ShoppingCart />} />
          <Route
            path="/Purchase/PhysicalCards/ShipToDonor"
             element={() =>
              props.isLoading ? (
                <LoadingSpinner />
              ) : (
                <PhysicalCards shippingScheme="donor" {...props} />
              )
            }
          /> */}
        </Routes>
      </Suspense>
      <Footer isDonateYourCard={isDonateYourCard} bottomBlurb={bottomBlurb} />
    </>
  )
}
